import React, { FC } from 'react'
import { useLayerWidgets } from 'services/widget'
import { Widget } from './Widget'

type WidgetGroupProps = {
  layerId: number
}

export const WidgetGroup: FC<WidgetGroupProps> = (props) => {
  const { widgets = [], status } = useLayerWidgets(props.layerId)

  if (status === 'loading') return null

  return (
    <>
      {widgets.map((widget) => (
        <Widget key={widget.id} widget={widget} layerId={props.layerId} />
      ))}
    </>
  )
}

WidgetGroup.displayName = 'WidgetGroup'
